import axios from 'axios';

import * as actionTypes from './actionTypes';
import {backendEndpoint} from '../utility';

export const appointmentHistoryGet = () => {
    return (dispatch, getState) => {
        const state = getState();
        const authToken = state.auth.token;
        const calendarId = state.auth.calendarId;

        let url = backendEndpoint + 'calendar/' + calendarId + '/get_appointments/?fetch_option=past';

        // load state information
        axios.get(url, {
            headers: {'Authorization': 'Token '+ authToken}
        })
            .then(function (response) {
                let appointments = response.data.appointments;
                dispatch(appointmentHistoryGetSucceeded(appointments));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const appointmentHistoryGetSucceeded = (appointments) =>{
    return {
        type: actionTypes.APPOINTMENT_HISTORY_GET,
        appointments: appointments,
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/appointmentHistory.js